import { pxToInt } from '../helpers';

export default function(){
    const forms = Array.from(document.querySelectorAll('[data-newsletter-form]'));

    const setupFormSizes = () => {
        forms.map(form => {
            const submit = form.querySelector('[type="submit"]');
            const input = form.querySelector('[type="email"]');

            const paddingLeft = window.getComputedStyle(input, null).getPropertyValue('padding-left');
            //input.style = `padding-right: ${parseInt(paddingLeft) + submit.clientWidth}px`;
        });
    }

    if(forms.length) {
        window.addEventListener('resize', throttle(setupFormSizes, 500));
        setupFormSizes();
    }

};
